/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type InFlightDeliveryOrderQueryVariables = Exact<{ [key: string]: never }>;

export type InFlightDeliveryOrderQuery = {
  readonly inFlightDeliveryOrder: { readonly __typename: 'Order'; readonly id: string } | null;
};

export const InFlightDeliveryOrderDocument = gql`
  query InFlightDeliveryOrder {
    inFlightDeliveryOrder {
      __typename
      id
    }
  }
`;

export function useInFlightDeliveryOrderQuery(
  options?: Omit<Urql.UseQueryArgs<InFlightDeliveryOrderQueryVariables>, 'query'>,
) {
  return Urql.useQuery<InFlightDeliveryOrderQuery, InFlightDeliveryOrderQueryVariables>({
    query: InFlightDeliveryOrderDocument,
    ...options,
  });
}
